import {useState,useEffect} from 'react'
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
const UniversityDeanLayout = (isUniversityPaymentStatus) => {
      const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
      const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
        useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);
 if (!isUniversityPaymentStatus) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-indigo-600"></div>

        {/* Text */}
        <p className="text-sm font-medium text-gray-600">
          Verifying your university access...
        </p>
      </div>
    </div>
  );
}
  return (
      <div className="flex min-h-screen">
      {/* Sidebar */}
      <Sidebar
        isCollapsed={isMobile ? true : isSidebarCollapsed} 
      />

      {/* Main content */}
      <div
        className={`flex-1 flex flex-col transition-margin duration-300
          ${
            isMobile
              ? "ml-20" 
              : isSidebarCollapsed
              ? "ml-20"
              : "ml-72"
          }`}
      >
        <Header toggleSidebar={toggleSidebar} isCollapsed={isSidebarCollapsed} />

        <div className="flex-1 p-2 md:p-6  overflow-auto space-y-6">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default UniversityDeanLayout